import { useApp } from '@hooks/app'
import { useApi } from '@hooks/api'
import { InviteBoxContext } from '../../context'
import { InviteOrgMemberContext } from './context'
import { useContextSelector } from 'use-context-selector'
import { InviteOrgMemberControllerProps } from './types'
import { MemberEntity } from '@entities/MemberEntity'
import { MembersApi } from '@services/api/member_api'

export const InviteOrgMemberController = (
  props: InviteOrgMemberControllerProps
): JSX.Element => {
  const api = useApi()
  const { setUser } = useApp()
  const setAccepting = useContextSelector(
    InviteBoxContext,
    (s) => s.setAccepting
  )
  const setDeclining = useContextSelector(
    InviteBoxContext,
    (s) => s.setDeclining
  )

  const handleUpdateStatus = (
    invite: MemberEntity,
    status: 'accept' | 'decline'
  ) => {
    api
      .instanceOf<MembersApi>(MembersApi)
      .handleInvite(invite.id, status)
      .then(setUser)
      .finally(() => {
        setDeclining(false)
        setAccepting(false)
      })
  }

  const handleAcceptInvite = () => {
    setDeclining(false)
    setAccepting(true)
    handleUpdateStatus(props.invite, 'accept')
  }

  const handleDeclineInvite = () => {
    setAccepting(false)
    setDeclining(true)
    handleUpdateStatus(props.invite, 'decline')
  }

  const state = {
    invite: props.invite,
    handleAcceptInvite,
    handleDeclineInvite,
  }
  return (
    <InviteOrgMemberContext.Provider value={state}>
      {props.children}
    </InviteOrgMemberContext.Provider>
  )
}
